import React from 'react';
import './PrivacyPolicy.css';

function PrivacyPolicy() {
  // Get current year for copyright notice
  const currentYear = new Date().getFullYear();

  return (
    <div className="page-container privacy-page">
      {/* Hero Banner Section */}
      <section className="privacy-hero-banner">
        <div className="hero-overlay"></div>
        <div className="container">
          <h1>Privacy Policy</h1>
          <p className="last-updated">Last Updated: March 15, {currentYear}</p>
        </div>
      </section>

      {/* Main Content Section */}
      <section className="privacy-content">
        <div className="container">
          <div className="policy-section">
            <h2>Introduction</h2>
            <p>
              At rkube, we respect your privacy and are committed to protecting your personal data. 
              This privacy policy will inform you about how we look after your personal data when you 
              visit our website and tell you about your privacy rights and how the law protects you.
            </p>
            <p>
              This privacy policy applies to all information collected through our website, 
              as well as any related services, sales, marketing or events.
            </p>
          </div>

          <div className="policy-section">
            <h2>Information We Collect</h2>
            <p>
              We collect several different types of information for various purposes to provide and 
              improve our service to you.
            </p>
            <h3>Personal Information</h3>
            <p>While using our service, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you. This may include:</p>
            <ul>
              <li>Name and contact details</li>
              <li>Email address</li>
              <li>Phone number</li>
              <li>Business information</li>
              <li>Billing and payment information</li>
              <li>Job application data (if applying for a position)</li>
            </ul>

            <h3>Usage Data</h3>
            <p>
              We may also collect information on how the service is accessed and used. This usage data 
              may include information such as your computer's Internet Protocol address (IP address), 
              browser type, browser version, the pages of our service that you visit, the time and date 
              of your visit, the time spent on those pages, unique device identifiers, and other 
              diagnostic data.
            </p>

            <h3>Cookies and Tracking Technologies</h3>
            <p>
              We use cookies and similar tracking technologies to track the activity on our service and 
              hold certain information. Cookies are files with a small amount of data which may include 
              an anonymous unique identifier.
            </p>
          </div>

          <div className="policy-section">
            <h2>How We Use Your Information</h2>
            <p>rkube uses the collected data for various purposes:</p>
            <ul>
              <li>To provide and maintain our service</li>
              <li>To notify you about changes to our service</li>
              <li>To provide customer support</li>
              <li>To provide analysis or valuable information so that we can improve the service</li>
              <li>To monitor the usage of the service</li>
              <li>To detect, prevent and address technical issues</li>
              <li>To fulfill any other purpose for which you provide it</li>
            </ul>
          </div>

          <div className="policy-section">
            <h2>Legal Basis for Processing Personal Information</h2>
            <p>
              We will only use your personal data when the law allows us to. Most commonly, we will 
              use your personal data in the following circumstances:
            </p>
            <ul>
              <li>Where we need to perform the contract we are about to enter into or have entered into with you</li>
              <li>Where it is necessary for our legitimate interests and your interests and fundamental rights do not override those interests</li>
              <li>Where we need to comply with a legal or regulatory obligation</li>
              <li>Where you have provided consent</li>
            </ul>
          </div>

          <div className="policy-section">
            <h2>Retention of Data</h2>
            <p>
              rkube will retain your personal data only for as long as is necessary for the purposes 
              set out in this privacy policy. We will retain and use your personal data to the extent 
              necessary to comply with our legal obligations, resolve disputes, and enforce our legal 
              agreements and policies.
            </p>
          </div>

          <div className="policy-section">
            <h2>Transfer of Data</h2>
            <p>
              Your information, including personal data, may be transferred to — and maintained on — 
              computers located outside of your state, province, country or other governmental jurisdiction 
              where the data protection laws may differ from those of your jurisdiction.
            </p>
            <p>
              If you are located outside the United States and choose to provide information to us, 
              please note that we transfer the data, including personal data, to the United States 
              and process it there.
            </p>
          </div>

          <div className="policy-section">
            <h2>Security of Data</h2>
            <p>
              The security of your data is important to us, but remember that no method of transmission 
              over the Internet, or method of electronic storage is 100% secure. While we strive to use 
              commercially acceptable means to protect your personal data, we cannot guarantee 
              its absolute security.
            </p>
          </div>

          <div className="policy-section">
            <h2>Your Data Protection Rights</h2>
            <p>
              Depending on your location and subject to applicable law, you may have the following rights 
              with respect to your personal data:
            </p>
            <ul>
              <li>The right to access, update or delete your personal information</li>
              <li>The right of rectification if information is inaccurate or incomplete</li>
              <li>The right to object to processing of your personal data</li>
              <li>The right of restriction of processing of your personal data</li>
              <li>The right to data portability (receiving a copy of your personal data)</li>
              <li>The right to withdraw consent where we rely on consent to process your personal data</li>
            </ul>
          </div>

          <div className="policy-section">
            <h2>Children's Privacy</h2>
            <p>
              Our service does not address anyone under the age of 18. We do not knowingly collect 
              personally identifiable information from anyone under the age of 18. If you are a parent 
              or guardian and you are aware that your child has provided us with personal data, 
              please contact us.
            </p>
          </div>

          <div className="policy-section">
            <h2>Changes to This Privacy Policy</h2>
            <p>
              We may update our privacy policy from time to time. We will notify you of any changes by 
              posting the new privacy policy on this page and updating the "Last Updated" date.
            </p>
            <p>
              You are advised to review this privacy policy periodically for any changes. Changes to 
              this privacy policy are effective when they are posted on this page.
            </p>
          </div>

          <div className="policy-section">
            <h2>Contact Us</h2>
            <p>
              If you have any questions about this privacy policy, please contact us:
            </p>
            <ul className="contact-list">
              <li>By email: support@rkubeservices.com</li>
              <li>By phone: +1 888-735-5515</li>
              <li>
                By mail: 4030 Wake Forest Rd, Raleigh, North Carolina
              </li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
}

export default PrivacyPolicy; 